import styled from 'styled-components';

export default styled.p`
  font-size: 14px;
  color: #54708c;
  font-family: Roboto;
  margin: 0 0 8px;
`;
